import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

// The zip is sent directly in the body as multipart form data, because the endpoint
// receives an IFormFile. The field name "zipFile" must match the parameter name of
// AlarmsDiffController.ProcessAlarmsDiff.
export const ProcessAlarmsDiffRequest = (zipFile) => {
	const formData = new FormData();
	formData.append('zipFile', zipFile);

	return AxiosRequest({
		method: 'POST',
		url: `${config.API_URL}AlarmsDiff/ProcessAlarmsDiff`,
		data: formData,
		headers: { 'Content-Type': 'multipart/form-data' }
	});
};
